





































































import {Component, Prop, Watch} from "vue-property-decorator";
    import {FormModel} from "ant-design-vue";
    import {FreightServiceStore} from "@/modules/freightservices/store";
    import EnumSelector from "@/shared/components/EnumSelector/index.vue";
    import { FreightServiceType } from "@/enums/type";
    import {assignValueToForm} from "@/shared/services/helper/utils";
    import {CommonStatus} from "@/enums/status";
    import PriceListSelector from "@/shared/components/PriceListSelector/index.vue";
    import {mixins} from "vue-class-component";
    import {CommonMixin} from "@/shared/services/mixin";
    import PostOfficeSelector from "@/shared/components/PostOfficeSelector/index.vue";
import AInputCustom from "@/shared/components/CustomInputAnt/index.vue";

    @Component({
        name: "FreightServiceForm",
        components: {AInputCustom, PostOfficeSelector, PriceListSelector, EnumSelector},
    })
    export default class extends mixins(CommonMixin) {
        @Prop()
        readonly id!: string;

        FreightServiceType = FreightServiceType;
        CommonStatus = CommonStatus;
        private form = {
            rowGuid: "",
            serviceCode: "",
            name: "",
            type: undefined,
            status: undefined,
            priceListDefaultId: undefined,
            postOfficeRowGuid: undefined
        };

        private rules = {
            serviceCode: [{ required: true, message: "Nhập mã dịch vụ", trigger: "change" }],
            name: [{ required: true, message: "Nhập tên dịch vụ", trigger: "change" }],
            type: [{ required: false, message: "Chọn kiểu dịch vụ", trigger: "change" }],
            status: [{ required: false }],
            postOfficeRowGuid: [{ required: false }],
        };

        private onSubmit() {
            (this.$refs.formFreightService as FormModel).validate(async valid => {
                if (!valid) return;
                try {
                    this.id
                        ? await FreightServiceStore.updateFreightService(this.form)
                        : await FreightServiceStore.createFreightService(this.form);
                    this.$message.success({
                        content: `${this.id ? 'Sửa' : 'Tạo'} dịch vụ thành công`
                    });
                    this.$router.push({ name: "listFreightService" });
                } catch (e) {
                    this.$message.error({
                        content: `${e.response?.data?.message || `${this.id ? 'Sửa' : 'Tạo'} dịch vụ thất bại`}`
                    })
                }
            })
        }

        async created() {
            if (this.isAdmin) {
                this.rules = {...this.rules, postOfficeRowGuid: [{ required: true, message: "Chọn bưu cục áp dụng", trigger: 'change' } as any]}
            }
            if (this.id) {
                try {
                    const data = await FreightServiceStore.singleFreightService(this.id);
                    this.form = assignValueToForm(this.form, data);
                } catch (e) {
                    this.$message.error({
                        content: `${e.response?.data?.message || "Đã có lỗi xảy ra"}`
                    })
                }
            }
        }
    }
